export function CollapseIcon(): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none">
            <rect
                x="2.75"
                y="2.75"
                width="12.5"
                height="12.5"
                rx="2.25"
                stroke="#A0AEC0"
                strokeWidth="1.5"
            />
            <line
                x1="6.75"
                y1="3"
                x2="6.75"
                y2="15"
                stroke="#A0AEC0"
                strokeWidth="1.5"
            />
        </svg>
    );
}
